<template>
  <h2 class="mb-24"><slot /></h2>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
